import * as S from './MonetizedPlatformsSection.styles'
import card_1_monetized from '../../Assets/card_1_monetized.png';
import card_2_monetized from '../../Assets/card_2_monetized.png';
import card_3_monetized from '../../Assets/card_3_monetized.png';
import card_4_monetized from '../../Assets/card_4_monetized.png';

export const MonetizedPlatformsSection = () => {
  return (
    <S.Wrapper
      id='industries'
    >
      <S.CardsBox>

        <S.Card
          className='
            sm:-mt-[-50px]
          '
        >
          <img src={card_1_monetized} alt="card_1_monetized" />
        </S.Card>

        <S.Card>
          <img src={card_2_monetized} alt="card_2_monetized" />
        </S.Card>

        <S.Card
          className='
            sm:-mt-[-50px]
          '
        >
          <img src={card_4_monetized} alt="card_4_monetized" />
        </S.Card>

        <S.Card>
          <img src={card_3_monetized} alt="card_3_monetized" />
        </S.Card>

      </S.CardsBox>

      <S.TextBox>
        <S.TextBoxH2>
          Monetized platforms are booming — from adult content and fan subscriptions to digital marketplaces and creator hubs.
        </S.TextBoxH2>

        <S.TextBoxP>
          These industries demand speed, privacy, and seamless integration.<br />PayQuest empowers international platforms to connect with Brazilian users via real-time PIX payins — compliant, discreet, and built for scale.
        </S.TextBoxP>
      </S.TextBox>

    </S.Wrapper>
  )
}
